import { type MessageDescriptor } from '@lingui/core'
import { msg } from '@lingui/core/macro'

export const TYPE_TEXT_MAP: Record<string, MessageDescriptor> = {
  FILE_UPLOAD: msg`File Upload`,
  WEBSITE_LOGIN: msg`Website Login`,
  EXTERNAL_ACTION: msg`External Action`,
  AUDIO_RECORDING: msg`Audio Recording`,
  VOICE_CONVERSATION: msg`Voice Conversation`,
  PROFILE: msg`Survey`,
  STAKING: msg`Stake SOL`,
  PROFICIENCY_ASSESSMENT: msg`Proficiency Assessment`,
  FREE_SPEECH: msg`Free Speech`,
  AUDIO_ANNOTATION: msg`Audio Annotation`,
  AUDIO_TRANSCRIPTION: msg`Audio Transcription`
}

export type MissionField = {
  id: string
  type: 'number' | 'select' | 'checkbox' | 'radio' | 'file' | 'photo'
  name: string
  description: string
  placeholder?: string
  valueSource?: 'dictionary:language' | 'dictionary:languageLevel' | 'dictionary:country'
  options?: { value: string; label: string }[]
}

export type MissionAvailabilityReason =
  | 'quota_unavailable'
  | 'profile_language'
  | 'profile_required'
  | 'language_assessment'
  | 'annotator_pretest'
  | 'not_whitelisted'
  | undefined
export const MISSION_AVAILABILITY_REASON_UNAVAILABLE: (string | undefined)[] = [
  'quota_unavailable',
  'profile_language',
  'not_whitelisted'
]

export type Mission = {
  availability: {
    available: boolean
    reason: MissionAvailabilityReason
  }
  id: string
  sortOrder: number
  title: string
  status: 'ENABLED' | 'DISABLED' | 'ENDED'
  reward: number
  rewardType?: 'points' | 'usd'
  shortDescription: string
  tags: string[]
  description: {
    sections: {
      name: string
      body: string
      image: string
    }[]
  }
  detailPath?: string
  view: {
    accruedReward: number
    joined?: number
    latestSubmissionStatus: null | 'IN_PROGRESS' | 'SUBMITTED' | 'COMPLETED' | 'FAILED'
    nextSubmissionAvailable: boolean
    nextSubmissionReward: number
    tooltip?: string
  }
} & (
  | {
      type: 'WEBSITE_LOGIN'
      view: {
        earnedPoints: number
        executedJobs: number
        multiplier: number
      }
    }
  | {
      type: 'FILE_UPLOAD'
      view: {
        uploadedBytes: number
        buttonText?: string
        fields?: MissionField[]
      }
    }
  | {
      type: 'EXTERNAL_ACTION'
    }
  | {
      type: 'AUDIO_RECORDING'
    }
  | {
      type: 'VOICE_CONVERSATION'
    }
  | {
      type: 'STAKING'
    }
  | {
      type: 'PROFILE'
    }
  | {
      type: 'PROFICIENCY_ASSESSMENT'
    }
  | {
      type: 'FREE_SPEECH'
    }
  | {
      type: 'AUDIO_ANNOTATION'
    }
  | {
      type: 'AUDIO_TRANSCRIPTION'
    }
)
